import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import * as Api from '../utils/Api'
// import * as App from '../utils/App'
import {API_URL, DC_URL} from '../constants/App'
// import cart from './modules/cart'
// import products from './modules/products'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // import some modules...
    // cart,
    // products
  },
  state: {
    businessList: [],
    userList: [],
    editingList: [],
    itemList: [],
    cartData: {},
    deliveryDestList: [],
    orderHistoryList: [],
    orderResrchList: [],
    newsList: []
  },
  mutations: {
    SET_BUSINESS (state, businessList) {
      state.businessList = businessList
    },
    SET_USERLIST (state, userList) {
      state.userList = userList
    },
    SET_EDITINGLIST (state, editingList) {
      state.editingList = editingList
    },
    SAVE_PRODUCT_LIST (state, itemList) {
      state.itemList = itemList
    },
    SET_CARTDATA (state, cartData) {
      state.cartData = cartData
    },
    SET_DELIVERY_DEST (state, deliveryDestList) {
      state.deliveryDestList = deliveryDestList
    },
    SET_ORDER_HISTORY (state, orderHistoryList) {
      state.orderHistoryList = orderHistoryList
    },
    SET_ORDER_RESRCH_HISTORY (state, orderResrchList) {
      state.orderResrchList = orderResrchList
    },
    SET_NEWS_LIST (state, newslist) {
      state.newsList = newslist
    }
  },
  methods: {
    bigImage: function (imgName) {
      let index = String(imgName).indexOf('.')
      let file = String(imgName).substring(0, index)
      let exp = String(imgName).substring(index, imgName.length)
      return file + '_B' + exp
    }
  },
  actions: {
    loadBusinessList ({ commit, state }, reload = false) {
      axios.get(API_URL.PLANNING + '/business'
      ).then(response => {
        commit('SET_BUSINESS', response.data.data)
      })
    },
    loadUserList ({ commit, state }) {
      axios.get(API_URL.ADMIN + '/list'
      ).then(response => {
        commit('SET_USERLIST', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    loadEditingList ({ commit, state }) {
      axios.get(API_URL.PLANNING + '/editing-list'
      ).then(response => {
        commit('SET_EDITINGLIST', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    loadUserListDc ({ commit, state }) {
      axios.get(DC_URL.USER + '/list'
      ).then(response => {
        commit('SET_USERLIST', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    async loadCartData ({ commit, state }) {
      await axios.get(DC_URL.PRODUCT + '/list'
      ).then(response => {
        commit('SET_CARTDATA', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    async loadDeliveryDest ({ commit, state }) {
      await axios.get(DC_URL.ORDER + '/delivery-list'
      ).then(response => {
        commit('SET_DELIVERY_DEST', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    loadOrderHistoryList ({commit, state}) {
      axios.get(DC_URL.ORDER + '/history/list'
      ).then(response => {
        commit('SET_ORDER_HISTORY', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    loadOrderResrchList ({commit, state}) {
      axios.get(DC_URL.ORDER + '/history/resrch-list'
      ).then(response => {
        commit('SET_ORDER_RESRCH_HISTORY', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    },
    loadNewsList ({commit, state}) {
      axios.get(DC_URL.TOP + '/newslist'
      ).then(response => {
        commit('SET_NEWS_LIST', response.data.data)
      }).catch((error) => {
        console.error(error)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main/js/store/index.js